import React, { useEffect, useState } from 'react';
import { Avatar, AvatarProps, Skeleton } from '@mui/material';

interface AvatarWithPlaceholderProps extends Omit<AvatarProps, 'src'> {
  src?: string | null;
}

const AvatarWithPlaceholder: React.FC<AvatarWithPlaceholderProps> = ({
  src,
  children,
  sx,
  ...rest
}) => {
  const [ready, setReady] = useState(!src);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!src) {
      setReady(true);
      setFailed(false);
      return;
    }
    setReady(false);
    setFailed(false);
    const img = new Image();
    img.onload = () => setReady(true);
    img.onerror = () => setFailed(true);
    img.src = src;
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src]);

  const showImage = !!src && ready && !failed;

  return (
    <Avatar {...rest} src={showImage ? src : undefined} sx={{ position: 'relative', ...sx }}>
      {src && !ready && !failed && (
        <Skeleton
          animation="wave"
          variant="circular"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        />
      )}
      {!showImage && children}
    </Avatar>
  );
};

export default AvatarWithPlaceholder;
